// Google Analytics Tracking ID
export const TRACKING_ID = "G-FZC8TC76L2";
